import "../css/main.css";

import { Application } from "@hotwired/stimulus";

const application = Application.start();

window.Stimulus = Application.start()

// Dynamically import all controllers from the components directory
const context = require.context('../components/', true, /_controller\.js$/);
context.keys().forEach((key) => {
  const controllerName = key.replace(/^.*[\\\/]/, '').replace('_controller.js', '');
  const controllerModule = context(key).default;
  application.register(controllerName, controllerModule);
});
